module.exports = __webpack_public_path__ + "img/eh.450b4000.svg";